import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  reduxFirstAppLoad:"true",
}

export const firstAppLoad = createSlice({
  name: 'firstLoad', //its not this that names the reducer for import in store. WTF?!
  initialState,
  reducers: {
    setFirstAppLoad: (state, action) => {
      state.reduxFirstAppLoad = action.payload
    }
  },
})

// Action creators are generated for each case reducer function
//export const { increment, decrement, incrementByAmount } = counterSlice.actions
export const { setFirstAppLoad } = firstAppLoad.actions
export default firstAppLoad.reducer